import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=738591f9&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"
import style0 from "./CardList.vue?vue&type=style&index=0&id=738591f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738591f9",
  null
  
)

export default component.exports